const { Message } = require('event-feed');

require('./message.scss');
const controller = require('./messageCtrl').default;
const template = require('./message.html');

const deps = [
  require('ngreact').name,
  require('ui/common/tooltip').name,
  require('ui/web/messageTooltip').name,
  require('data/model/message').name,
  require('ui/web/confirmDialog').name,
  require('data/service/urlParser').name,
  require('data/service/messageParser').name,
  require('ui/web/messagePayload').name,
  require('ui/web/notifications').name,
];

const mod = angular.module('bench.ui.web.message', deps);

mod.directive('blMessageReact', [
  'reactDirective',
  reactDirective =>
    reactDirective(Message, [
      'showDate',
      'showAvatar',
      'showSmsIndicator',
      'showToolbar',
      'showEdit',
      'showFailed',
      'showTime',
      'date',
      'isFirst',
      'avatarEmail',
      'displayName',
      'initials',
      'isAuthorClient',
      'onEdit',
      'onCopyError',
      'onCopySuccess',
      'rawMessagePayload',
      'clientId',
      'isFormattingEnabled',
      'isBookkeeper',
      'isInProgress',
      'payload',
      'displayPayloads',
      'sentWithSms',
      'onCancel',
      'onChange',
      'onSave',
      'value',
      'onDelete',
      'onToolbarDelete',
      'onFailedDelete',
      'onResend',
      'hasReadReceipt',
      'showMobileIcon',
    ]),
]);

mod.component('blMessage', {
  bindings: {
    messageId: '=',
    showAvatar: '=',
    showDate: '=',
    showTime: '=',
    showMessageSource: '<',
    bookkeeperId: '=?',
    editable: '=',
    isFirst: '=?',
    isNewMessageFormattingEnabled: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
});

module.exports = mod;
